import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Stack,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import CloseIcon from "@mui/icons-material/Close";
import Sidebar from "../../Drawer/Sidebar";
import TableCompo from "../Table/TableCompo";
import {
  fetchCustomerListRequest,
  clearCustomerMessages,
  updateCustomerStatusRequest,
  getCustomerDetailsRequest,
  sendGiftRequest,
  extractCustomerDataRequest,
  holdingsExportRequest,
  updateCustomerRequest,
  monthEndReportRequest,
} from "../../../redux/customer/CustomerSlice";
import { CustomerType } from "../../../configs/constants";
import { getMetalsRequest } from "../../../redux/GetMetals/metalSlice";
import { minWidth } from "@mui/system";
import NomineeDialog from "./NomineeDialog";
import { canShowPermission } from "../Permissions/permissionObject";
import { Check, Close, FileDownloadOutlined } from "@mui/icons-material";

const CustomerList = () => {
  const dispatch = useDispatch();
  const {
    customer = [],
    loading,
    totalCount,
  } = useSelector((state) => state.customer);
  const package_name = useSelector(
    (state) => state?.appConfig?.configData.package_name || "",
  );
  const decimal = useSelector(
    (state) => state?.appConfig?.configData?.decimalPrecision || 4,
  );
  const monthlyHoldingsEnabled = useSelector(
    (state) => state?.appConfig?.configData?.featureToggle?.Monthly_Holdings === true || state?.appConfig?.configData?.featureToggle?.monthly_holdings === true,
  );
  console.log("decimal", decimal);
  if (!Array.isArray(customer)) {
    console.warn("Customer is not an array:", customer);
  }

  const metalState = useSelector((state) => state.metal || {});
  const data = metalState.data || {};

  const enabledMetals = data.metals || [];

  useEffect(() => {
    dispatch(getMetalsRequest());
  }, [dispatch]);

  const [openGiftDialog, setOpenGiftDialog] = useState(false);
  const [giftForm, setGiftForm] = useState({
    metal: "",
    occasion: "",
    validDays: "",
    weight: "",
  });

  useEffect(() => {
    if (openGiftDialog) {
      setGiftForm({
        metal: "",
        occasion: "",
        validDays: "",
        weight: "",
      });
    }
  }, [openGiftDialog]);

  const [giftCustomerId, setGiftCustomerId] = useState(null);

  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const { selectedCustomerDetails } = useSelector((state) => state.customer);
  // const [columns, setColumns] = useState([]);
  const [isSendingGift, setIsSendingGift] = useState(false);

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  const [statusConfirmDialogOpen, setStatusConfirmDialogOpen] = useState(false);
  const [statusCustomerId, setStatusCustomerId] = useState(null);
  const [openReferralDialog, setOpenReferralDialog] = useState(false);
  const [referralDetails, setReferralDetails] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [openNomineeDialog, setOpenNomineeDialog] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [altMobileValue, setAltMobileValue] = useState("");
  console.log("selectedCustomer", selectedCustomer);

  useEffect(() => {
    dispatch(fetchCustomerListRequest({ start: page * limit, limit, search }));
  }, [dispatch, page, limit, search]);

  const handleCustomerTypeToggle = (row) => {
    const newType =
      row.customer_type === CustomerType.vip
        ? CustomerType.standard
        : CustomerType.vip;

    const payload = {
      cid: row._id,
      customer_type: newType,
    };

    dispatch(updateCustomerStatusRequest(payload));
  };

  const transactions = selectedCustomerDetails?.transactions || [];

  const purchases = transactions.filter(
    (tx) =>
      tx.orderType === "Buy" ||
      tx.orderType === "Sip" ||
      tx.orderType === "Installments" ||
      tx.orderType === "Gift" ||
      tx.orderType === "Redeem" ||
      tx.orderType === "Sell" ||
      tx.orderType === "GiftReceived" ||
      tx.orderType === "GiftSent" ||
      tx.orderType === "Installment",
  );

  const firstPurchaseDate = purchases[0]?.createdAt
    ? new Date(purchases[0].createdAt).toLocaleDateString("en-GB")
    : "N.A";

  const totalPurchases = purchases.length;

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changeRowsPerPage":
        setPage(0);
        setLimit(tableState["rowsPerPage"]);
        break;
      case "search":
        setSearch(tableState.searchText || "");
        setPage(0);
        break;
      case "changePage":
        setPage(tableState["page"]);
        setLimit(tableState["rowsPerPage"]);

        break;
    }
  };
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const stored = localStorage.getItem("userPermissions");
    if (stored) {
      try {
        setPermissions(JSON.parse(stored));
      } catch (e) {
        console.error("permission parse error", e);
      }
    }
  }, []);
  const canCreate = canShowPermission(permissions, "allCustomers", "create");
  const canEdit = canShowPermission(permissions, "allCustomers", "edit");

  const handleAltMobileUpdate = (row) => {
    const isValidMobile = /^[1-9][0-9]{5,12}$/.test(altMobileValue);

    if (!isValidMobile) {
      toast.error("Enter valid mobile number");
      return;
    }

    const payload = {
      address: [
        {
          area: row?.address?.area || "",
          city: row?.address?.city || "",
          pincode: row?.address?.pincode || "",
          state: row?.address?.state || "",
          addressType: row?.address?.addressType || "",
        },
      ],
      firstName: row.firstName || "",
      lastName: row.lastName || "",
      gender: row.gender || "",
      dateOfBirth: row.dateOfBirth || 0,
      ddmm: row.ddmm || "",
      referralcode: row?.referralcode || "",
      marritalStatus: row?.marritalStatus || "",
      email: row?.email || "",
      phone: row?.phone || "",
      deviceDetails: row?.logindetails?.deviceDetails || "",
      jeweller: row?.jeweller || "",
      refreshToken: "",
      accessToken: "",
      _id: row._id,
      customer_type: row?.customer_type || "",
      joining_code: row?.joining_code || "",
      alternateMobile: altMobileValue,
    };

    dispatch(updateCustomerRequest(payload));

    setEditingRowId(null);
  };

  const columns = [
    {
      field: "createdAt",
      headerName: "Registration Date",
      minWidth: 220,
      render: (val, row) => {
        if (!row?.createdAt) return "N/A";
        const date = new Date(row.createdAt);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;
        return `${day}-${month}-${year} ${hour12}:${minutes} ${ampm}`;
      },
    },
    {
      field: "fullName",
      headerName: "Name",
      render: (val, row) =>
        `${row.firstName || ""} ${row?.middleName || ""} ${row.lastName || ""}`.trim(),
    },
    {
      field: "phone",
      headerName: "Phone",
      minWidth: 150,
      render: (val, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span>{row.phone}</span>
          {canEdit && (
            <button
              style={{
                backgroundColor: "#ffc107",
                color: "#000",
                border: "none",
                padding: "5px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                setGiftCustomerId(row._id);
                dispatch(getCustomerDetailsRequest({ customerId: row._id }));
                setOpenGiftDialog(true);
              }}
            >
              Gift
            </button>
          )}
        </div>
      ),
    },
    {
      field: "State",
      headerName: "State",
      render: (val, row) => `${row?.address?.state ?? "N.A"} `,
    },
    { field: "gender", headerName: "Gender" },
    {
      field: "age",
      headerName: "Age",
      minWidth: 50,
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const dob = new Date(row.dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        const dayDiff = today.getDate() - dob.getDate();
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
        }
        return age;
      },
    },
    {
      field: "birthdayRemainingDays",
      headerName: "Birthday Remaining Days",
      minWidth: 100,
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const today = new Date();
        const dob = new Date(row.dateOfBirth);
        let nextBirthday = new Date(
          today.getFullYear(),
          dob.getMonth(),
          dob.getDate(),
        );
        if (nextBirthday < today) {
          nextBirthday.setFullYear(today.getFullYear() + 1);
        }
        const diffTime = nextBirthday - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return `${diffDays} days`;
      },
    },
    {
      field: "currentLoginAt",
      headerName: "Last Login",
      minWidth: 200,
      render: (val, row) => {
        if (!row.logindetails) return "N/A";

        const date = new Date(row.logindetails.currentLoginAt);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;

        return `${day}-${month}-${year} ${hour12}:${minutes} ${ampm}`;
      },
    },
    {
      field: "sipActive",
      headerName: "Sip Active",
      render: (val, row) => {
        return row.sipActive ? row.sipActive : "N.A";
      },
    },
    {
      field: "enabled",
      headerName: "STATUS",
      render: (val, row) => {
        if (!canEdit) {
          return (
            <span
              style={{
                color: row.enabled ? "green" : "red",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              {row.enabled ? "ENABLED" : "DISABLED"}
            </span>
          );
        }

        return (
          <span
            style={{
              color: row.enabled ? "green" : "red",
              fontWeight: "bold",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
            onClick={() => {
              setStatusCustomerId(row);
              setStatusConfirmDialogOpen(true);
            }}
          >
            {row.enabled ? "ENABLED" : "DISABLED"}
          </span>
        );
      },
    },
    {
      field: "dateOfBirth",
      headerName: "Date Of Birth",
      render: (val, row) => {
        if (!row.dateOfBirth) return "N/A";
        const date = new Date(row.dateOfBirth);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      field: "alternateMobile",
      headerName: "Alternate Mobile",
      minWidth: 200,
      render: (_, row) => {
        const isEditing = editingRowId === row._id;

        return (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {isEditing ? (
              <>
                <input
                  value={altMobileValue}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    if (val.length <= 10) {
                      setAltMobileValue(val);
                    }
                  }}
                  style={{
                    width: "100px",
                    minWidth: "80px",
                    maxWidth: "120px",
                    padding: "3px",
                    fontSize: "12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />

                <Check
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    background: "#E2E2EA",
                    borderRadius: "50%",
                    width: 26,
                    height: 26,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#1d832e",
                    transition: "all 0.2s ease",

                    "&:hover": {
                      background: "#1d832e",
                      color: "#fff",
                      transform: "scale(1.1)",
                    },
                  }}
                  onClick={() => handleAltMobileUpdate(row)}
                />

                <Close
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    background: "#E2E2EA",
                    borderRadius: "50%",
                    width: 26,
                    height: 26,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                    transition: "all 0.2s ease",

                    "&:hover": {
                      background: "#dc3545",
                      color: "#fff",
                      transform: "scale(1.1)",
                    },
                  }}
                  onClick={() => setEditingRowId(null)}
                />
              </>
            ) : (
              <>
                <button
                  style={{
                    backgroundColor: "#ffc107",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setEditingRowId(row._id);
                    setAltMobileValue(row?.alternateMobile || "");
                  }}
                >
                  {row?.alternateMobile || "Add"}
                </button>
              </>
            )}
          </div>
        );
      },
    },
    {
      field: "Details",
      headerName: "Details",
      minWidth: 90,
      render: (val, row) => (
        <button
          style={{
            backgroundColor: "#ffc107",
            color: "#000",
            border: "none",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => {
            setSelectedCustomerId(row._id);
            dispatch(getCustomerDetailsRequest({ customerId: row._id }));
            setOpenCustomerDialog(true);
          }}
        >
          View
        </button>
      ),
    },

    {
      field: "kycstatus",
      headerName: "KYC Status",
      render: (val, row) => {
        const status = row.kycstatus || "N/A";
        const colorMap = {
          APPROVED: "green",
          PENDING: "orange",
          REJECTED: "red",
        };
        return (
          <span
            style={{
              backgroundColor: colorMap[status] || "gray",
              color: "#fff",
              padding: "4px 8px",
              borderRadius: "6px",
              fontWeight: "bold",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      field: "customer_type",
      headerName: "Customer Type",
      render: (_, row) => {
        if (!canEdit) {
          return <Typography variant="body2">{row.customer_type}</Typography>;
        }
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Switch
              key={row._id}
              checked={row.customer_type == CustomerType.vip ? true : false}
              onChange={() => handleCustomerTypeToggle(row)}
              color="primary"
            />
            <Typography variant="body2">{row.customer_type}</Typography>
          </Box>
        );
      },
    },
    {
      field: "referralcode",
      headerName: "Referral Code",
      render: (val, row) =>
        row?.referralcode ? (
          <button
            style={{
              background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
              fontFamily: "inherit",
              color: "#fff",
              border: "none",
              padding: "5px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={() => {
              sessionStorage.setItem("selectedReferralCode", row.referralcode);
              window.location.href = "/BirthdayCustomerList";
            }}
          >
            {row.referralcode}
          </button>
        ) : (
          "N.A"
        ),
    },
    {
      field: "joining_code",
      headerName: "Joining Code",
      render: (_, row) => row?.joining_code ?? 0,
    },
    {
      field: "generatedCount",
      headerName: "Generated Count",
      render: (_, row) => row?.referralStats?.generatedCount ?? 0,
    },
    {
      field: "usedCount",
      headerName: "Used Count",
      render: (_, row) => row?.referralStats?.usedCount ?? 0,
    },
    {
      field: "totalDiamondPoints",
      headerName: "Diamond Points",
      minWidth: 120,
      render: (_, row) => row?.totalAvailableDiamondPoints ?? 0,
    },
    {
      field: "nominee",
      headerName: "Nominee",
      minWidth: 155,
      render: (_, row) => {
        if (!canEdit) {
          return (
            <Typography variant="body2">
              {row?.nominee ? "Nominee Added" : "No Nominee"}
            </Typography>
          );
        }

        return (
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setSelectedCustomer(row);
              setOpenNomineeDialog(true);
            }}
          >
            {row?.nominee ? "Update Nominee" : "Add Nominee"}
          </Button>
        );
      },
    },
    // {
    //   field: "points",
    //   headerName: "Points",
    //   minWidth: 100,
    //   render: (_, row) => (
    //     <Box
    //       sx={{ whiteSpace: "normal", wordBreak: "break-word", maxWidth: 100 }}
    //     >
    //       {row.points}
    //     </Box>
    //   ),
    // },
  ];

  const customerExport = async () => dispatch(extractCustomerDataRequest());
  const holdingsExport = async () => {
    console.log("dayanand");
    dispatch(holdingsExportRequest());
  };

  const getPrevMonth = () => {
    const d = new Date();
    // d.setDate(1);
    // d.setMonth(d.getMonth() - 1);
    // return { month: d.getMonth() + 1, year: d.getFullYear() };
    return { month: d.getMonth() + 1, year: d.getFullYear() };
  };

  const { month: reportMonth, year: reportYear } = getPrevMonth();
  const monthEndFileName = `customermonthend-${reportYear}-${String(reportMonth).padStart(2, "0")}.xlsx`;

  const monthEndExport = () =>
    dispatch(monthEndReportRequest({ month: reportMonth, year: reportYear }));

  const reportActions = [
    {
      label: "Customers",
      hint: "Customer list · CSV",
      onGenerate: customerExport,
      href: `${process.env.REACT_APP_API_BASE_URL}/static_data/${package_name}/customerdata.csv?nocache=${Date.now()}`,
      download: "customerdata.csv",
    },
    {
      label: "Holdings",
      hint: "Holdings · Excel",
      onGenerate: holdingsExport,
      href: `${process.env.REACT_APP_API_BASE_URL}/static_data/${package_name}/customerholdings.xlsx?nocache=${Date.now()}`,
      download: "customerholdings.xlsx",
    },
    {
      label: "Month End",
      hint: "This month · Excel",
      onGenerate: monthEndExport,
      href: `${process.env.REACT_APP_API_BASE_URL}/static_data/${package_name}/${monthEndFileName}?nocache=${Date.now()}`,
      download: monthEndFileName,
      requiresMonthlyHoldings: true,
    },
  ].filter(
    (report) => !report.requiresMonthlyHoldings || monthlyHoldingsEnabled,
  );

  return (
    <Box sx={{ width: "98%" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          mt: 0,
          mb: { xs: 5, md: 5 },
          background: "#fff",
          borderRadius: "3px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} p={2} fontFamily={"Aeonik"}>
          Customer List
        </Typography>
        <CardContent
          sx={{
            width: "100%",
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                gap: 1.5,
                mb: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography
                fontWeight={700}
                fontSize={15}
                fontFamily="Aeonik"
                color="#222"
              >
                Reports
              </Typography>
              <Typography fontSize={12} color="#888">
                Generate the file first, then download it.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                border: "1px solid #ececec",
                borderRadius: "12px",
                overflow: "hidden",
                bgcolor: "#fff",
              }}
            >
              {reportActions.map((report, index) => (
                <Box
                  key={report.label}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1.5,
                    borderRight: {
                      xs: "none",
                      md:
                        index < reportActions.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    },
                    borderBottom: {
                      xs:
                        index < reportActions.length - 1
                          ? "1px solid #ececec"
                          : "none",
                      md: "none",
                    },
                  }}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: "#222",
                        lineHeight: 1.2,
                      }}
                    >
                      {report.label}
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#888", mt: 0.25 }}>
                      {report.hint}
                    </Typography>
                  </Box>
                  <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={report.onGenerate}
                      sx={{
                        textTransform: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#333",
                        borderColor: "#ddd",
                        borderRadius: "8px",
                        px: 1.25,
                        "&:hover": {
                          borderColor: "#7028DA",
                          color: "#7028DA",
                          bgcolor: "#faf7ff",
                        },
                      }}
                    >
                      Generate
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      component="a"
                      href={report.href}
                      download={report.download}
                      startIcon={<FileDownloadOutlined sx={{ fontSize: 16 }} />}
                      sx={{
                        textTransform: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        bgcolor: "#7028DA",
                        borderRadius: "8px",
                        boxShadow: "none",
                        px: 1.25,
                        "&:hover": { bgcolor: "#5b1fba", boxShadow: "none" },
                      }}
                    >
                      Download
                    </Button>
                  </Stack>
                </Box>
              ))}
            </Box>
          </Box>
          <TableCompo
            columns={columns}
            data={JSON.parse(JSON.stringify(customer))}
            loading={loading}
            totalCount={totalCount}
            page={page}
            limit={limit}
            pageSize={limit}
            onTableChange={handleTableChange}
            hideExportButtons
          />
        </CardContent>
      </Box>

      {/* View Customer Dialog */}
      <Dialog
        open={openCustomerDialog}
        onClose={() => setOpenCustomerDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Customer Full Details
          <IconButton onClick={() => setOpenCustomerDialog(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedCustomerDetails && selectedCustomerDetails.customer ? (
            <>
              <Typography variant="h6">Customer Info</Typography>
              <Table size="small" sx={{ mb: 3 }}>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <b>Name</b>
                    </TableCell>
                    <TableCell>
                      {selectedCustomerDetails.customer.firstName || "N.A"}{" "}
                      {selectedCustomerDetails.customer.middleName || ""}{" "}
                      {selectedCustomerDetails.customer.lastName || ""}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>Total Purchases</b>
                    </TableCell>
                    <TableCell>{totalPurchases}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>First Purchase Date</b>
                    </TableCell>
                    <TableCell>{firstPurchaseDate}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <b>Last Login</b>
                    </TableCell>
                    <TableCell>
                      {selectedCustomerDetails.customer.logindetails
                        ? new Date(
                            selectedCustomerDetails.customer.logindetails
                              ?.currentLoginAt,
                          ).toLocaleDateString("en-GB")
                        : "N.A"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>

              <Typography variant="h6">Holdings</Typography>
              <Table size="small" sx={{ mb: 3 }}>
                <TableHead sx={{ backgroundColor: "#b293c7ff" }}>
                  <TableRow>
                    <TableCell>Metal Name</TableCell>
                    <TableCell>Purity</TableCell>
                    <TableCell>Balance</TableCell>
                    <TableCell>SIP Balance</TableCell>
                    <TableCell>Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(selectedCustomerDetails.holdings || []).length > 0 ? (
                    selectedCustomerDetails.holdings.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            {item.bullion?.metalName || "Money"}
                          </TableCell>
                          <TableCell>{item.bullion?.purity || "N.A"}</TableCell>
                          <TableCell>
                            {item.availableBalance != null
                              ? Number(item.availableBalance).toFixed(decimal)
                              : "N.A"}
                          </TableCell>
                          <TableCell>
                            {item.metalsip != null
                              ? Number(item.metalsip).toFixed(decimal)
                              : "N.A"}
                          </TableCell>
                          <TableCell>
                            {item?.updatedAt
                              ? new Date(item.updatedAt).toLocaleDateString(
                                  "en-GB",
                                )
                              : "N.A"}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3}>N.A</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <Typography variant="h6">Transactions</Typography>
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#b293c7ff" }}>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Metal Name</TableCell>
                    <TableCell>Purity</TableCell>
                    <TableCell>Order Type</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(selectedCustomerDetails.transactions || []).length > 0 ? (
                    selectedCustomerDetails.transactions.map((tx, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {tx?.createdAt
                            ? new Date(tx.createdAt).toLocaleDateString("en-GB")
                            : "N.A"}
                        </TableCell>
                        <TableCell>
                          {tx.bullion?.metalName || "Money"}
                        </TableCell>
                        <TableCell>{tx.bullion?.purity || "N.A"}</TableCell>
                        <TableCell>{tx.orderType ?? "N.A"}</TableCell>
                        <TableCell>
                          {tx.final_amount.toFixed(2) || "N.A"}
                        </TableCell>
                        <TableCell>{tx.weight || "N.A"}</TableCell>
                        <TableCell>{tx.status || "N.A"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>N.A</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </>
          ) : (
            <Typography>Data Not Available</Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* Status Confirmation Dialog */}
      <Dialog
        open={statusConfirmDialogOpen}
        onClose={() => setStatusConfirmDialogOpen(false)}
      >
        <DialogTitle>Change Customer Status</DialogTitle>
        <DialogContent>
          <Typography>
            Do you want to change the status of this customer?
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
            }}
          >
            <button
              style={{
                padding: "6px 12px",
                backgroundColor: "#4caf50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(
                  updateCustomerStatusRequest({
                    cid: statusCustomerId._id,
                    enabled: !statusCustomerId.enabled,
                  }),
                );
                setStatusConfirmDialogOpen(false);
              }}
            >
              Yes
            </button>
            <button
              style={{
                padding: "6px 12px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => setStatusConfirmDialogOpen(false)}
            >
              No
            </button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openGiftDialog}
        onClose={() => setOpenGiftDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          fontFamily={"Aeonik"}
          fontWeight={700}
          fontSize={24}
          sx={{
            background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
            color: "#fff",
          }}
        >
          Send Gift
          <IconButton
            onClick={() => setOpenGiftDialog(false)}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              background: "#E2E2EA",
              borderRadius: "50%",
              width: 26,
              height: 26,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#646464",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {selectedCustomerDetails && selectedCustomerDetails.customer ? (
            <Box mb={2}>
              <Typography
                variant="h6"
                fontWeight="bold"
                fontFamily={"Aeonik"}
                fontSize={24}
              >
                {`${selectedCustomerDetails.customer.firstName || "N.A"} ${
                  selectedCustomerDetails.customer.lastName || ""
                } - ${selectedCustomerDetails.customer.phone || "N.A"}`}
              </Typography>
            </Box>
          ) : (
            <Typography
              fontFamily={"Aeonik"}
              fontWeight={700}
              fontSize={24}
              mb={2}
              color="#7028DA"
            >
              Loading customer info...
            </Typography>
          )}
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Metal Select */}
            <label>Metal</label>
            <select
              value={giftForm.metal}
              onChange={(e) =>
                setGiftForm((prev) => ({ ...prev, metal: e.target.value }))
              }
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #cdcdcd",
              }}
            >
              <option value="">Select Metal</option>
              {enabledMetals
                .filter((metal) => metal.status === true)
                .map((metal) => (
                  <option key={metal._id} value={metal._id}>
                    {`${metal.metalName} - ${metal.karat}K - ${metal.purity}`}
                  </option>
                ))}
            </select>

            {/* Occasion */}
            <label>Occasion</label>
            <input
              type="text"
              placeholder="Enter Occasion"
              value={giftForm.occasion}
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]*$/.test(input)) {
                  setGiftForm((prev) => ({ ...prev, occasion: input }));
                }
              }}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #cdcdcd",
              }}
            />

            {/* Valid Days */}
            <label>Validity (Days)</label>
            <input
              type="text"
              placeholder="Enter Valid Days"
              value={giftForm.validDays}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d*$/.test(input)) {
                  setGiftForm((prev) => ({ ...prev, validDays: input }));
                }
              }}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #cdcdcd",
              }}
            />
            {/* Gift Weight */}
            <label>Gift Weight</label>
            <input
              type="text"
              placeholder="Enter Weight"
              value={giftForm.weight}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d*\.?\d{0,3}$/.test(input)) {
                  setGiftForm((prev) => ({ ...prev, weight: input }));
                }
              }}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #cdcdcd",
              }}
            />
            {/* Send Gift Button */}
            <button
              style={{
                background:
                  "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
                marginTop: "10px",
                height: "55px",
                cursor: isSendingGift ? "not-allowed" : "pointer",
                opacity: isSendingGift ? 0.6 : 1,
              }}
              disabled={isSendingGift}
              onClick={() => {
                if (isSendingGift) return; // prevent multiple clicks
                setIsSendingGift(true);

                // Trim inputs
                const trimmedWeight = String(giftForm.weight).trim();
                const trimmedValidDays = String(giftForm.validDays).trim();
                const trimmedOccasion = String(giftForm.occasion).trim();

                const selectedMetal = enabledMetals.find(
                  (m) => m._id === giftForm.metal,
                );

                if (!selectedMetal || !selectedCustomerDetails?.customer?._id) {
                  toast.error("Please select a valid metal and customer.");
                  setIsSendingGift(false);
                  return;
                }

                if (!trimmedWeight) {
                  toast.error("Please Enter Weight.");
                  setIsSendingGift(false);
                  return;
                }

                if (!trimmedValidDays) {
                  toast.error("Please Enter valid Days.");
                  setIsSendingGift(false);
                  return;
                }

                if (!trimmedOccasion) {
                  toast.error("Please Enter occasion.");
                  setIsSendingGift(false);
                  return;
                }

                const payload = {
                  weight: Number(trimmedWeight),
                  metalName: selectedMetal.metalName,
                  purity: Number(selectedMetal.purity),
                  type: "Buy", // hardcoded
                  customer: selectedCustomerDetails.customer._id,
                  occasion: trimmedOccasion,
                  giftvalidity: Number(trimmedValidDays),
                };

                dispatch(sendGiftRequest(payload));

                // Simulate delay for loader or until API finishes
                setTimeout(() => {
                  setIsSendingGift(false);
                  setOpenGiftDialog(false);
                }, 3000); // adjust delay as needed
              }}
            >
              {isSendingGift ? "Sending..." : "Send Gift"}
            </button>
          </Box>
        </DialogContent>
      </Dialog>
      <NomineeDialog
        open={openNomineeDialog}
        onClose={() => setOpenNomineeDialog(false)}
        customer={selectedCustomer}
      />
    </Box>
  );
};

export default CustomerList;
